exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".navigationTree {\r\n    margin-top: 10px;\r\n}\r\n\r\n.navigationItem {\r\n    font-size: 14px;\r\n    color: #354784;\r\n}\r\n\r\n.navigationItem:active {\r\n    text-decoration: none;    \r\n}\r\n\r\n    .navigationItem:hover {\r\n        text-decoration: none;\r\n    }\r\n\r\n    .navigationItem:visited {\r\n        text-decoration: none;\r\n    }\r\n\r\n    .navigationItem:focus {\r\n        text-decoration: none;\r\n        background-color: none;\r\n    }\r\n\r\n.navigationIcon {\r\n    font-size: 20px;\r\n    margin-right: 5px;\r\n    color: #354784;\r\n}\r\n\r\n.dx-treeview-item .dx-treeview-item-content span {\r\n    vertical-align: top;\r\n}\r\n\r\n.dx-treeview-item.dx-state-disabled {\r\n    opacity: 1;\r\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./App/containers/navigation/navigation.css
// module id = 1286
// module chunks = 0